export const FORM = 'INBOX_MESSAGE_COMPOSER';
